package com.isaias.fyattravel.web.navigation

import kotlinx.browser.window

/**
 * Navigate to a route
 */
fun navigateTo(route: String) {
    val normalized = if (route.startsWith("/")) route else "/$route"
    window.location.hash = normalized
}
